import loadable from '@loadable/component'

export default [
  // 直播数据
  {
    path: '/newAnchorcenter/LiveData',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveData" */ '~/pages/NewAnchorcenter/LiveData'
        )
    ),
  },
  {
    path: '/newAnchorcenter/HouseOwnerGuidance',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-HouseOwnerGuidance" */ '~/pages/NewAnchorcenter/HouseOwnerGuidance'
        )
    ),
  },
  {
    path: '/newAnchorcenter/active',
    exact: true,
    component: loadable(
        () =>
            import(
                /* webpackChunkName: "page-NewAnchorcenter-active" */ '~/pages/NewAnchorcenter/Active'
                )
    ),
  },
  {
    path: '/anchorMotivation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-AnchorMotivation" */ '~/pages/NewAnchorcenter/AnchorMotivation/index'
        )
    ),
  },
  {
    path: '/anchorMotivation/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-AnchorMotivation-rule" */ '~/pages/NewAnchorcenter/AnchorMotivation/rule'
        )
    ),
  },
  {
    path: '/anchorMotivation/guide',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-AnchorMotivation-guide" */ '~/pages/NewAnchorcenter/AnchorMotivation/guide'
        )
    ),
  },
  {
    path: '/newAnchorcenter/AnchorSalary',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-AnchorSalary" */ '~/pages/NewAnchorcenter/AnchorSalary'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveDataDetail" */ '~/pages/NewAnchorcenter/LiveDataDetail'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/sessionDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveSessionDetail" */ '~/pages/NewAnchorcenter/LiveSessionDetail'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/query',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-LiveDataQuery" */ '~/pages/NewAnchorcenter/LiveDataQuery'
        )
    ),
  },
  {
    path: '/newAnchorcenter/LiveData/salaryDetail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-NewAnchorcenter-SalaryDetail" */ '~/pages/NewAnchorcenter/SalaryDetail'
        )
    ),
  },
]
